// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__Dneow","closeModalIcon":"PopUpModal_closeModalIcon__FLFdG"};